import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import './lib/auth'; // Initialize axios Bearer token interceptor
import { initAnalytics } from './lib/analytics';

// Kick off analytics tracker (page views + SPA nav)
initAnalytics();

// Components
import Header from "./components/Header";
import AnnouncementBanner from "./components/AnnouncementBanner";
import HeroSection from "./components/HeroSection";
import PacksSection from "./components/PacksSection";
import ProcessSection from "./components/ProcessSection";
import WorldCupPromoSection from "./components/WorldCupPromoSection";
import AdvantagesSection from "./components/AdvantagesSection";
import ProductPresentationSection from "./components/ProductPresentationSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import ReservationPage from "./components/ReservationPage";
import LoginPage from "./components/LoginPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import ContactPage from "./components/ContactPage";
import AuthCallback from "./components/AuthCallback";
import ClientDashboard from "./components/ClientDashboard";
import AdminDashboard from "./components/AdminDashboard";
import OrderProcessingPage from "./pages/OrderProcessingPage";
import ReturnProcessingPage from "./pages/ReturnProcessingPage";
import InspectionProcessingPage from "./pages/InspectionProcessingPage";
import CGVPage from "./pages/CGVPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";
import QuoteAcceptPage from "./pages/QuoteAcceptPage";
import SEPAPendingPage from "./pages/SEPAPendingPage";
import SEPASignPage from "./pages/SEPASignPage";
import LightPage from "./pages/LightPage";
import CookieBanner from "./components/CookieBanner";

const Home = () => {
  return (
    <div className="min-h-screen">
      <AnnouncementBanner />
      <Header />
      <main>
        <HeroSection />
        <PacksSection />
        <ProcessSection />
        <WorldCupPromoSection />
        <ProductPresentationSection />
        <AdvantagesSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

// Router with auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/reservation" element={<ReservationPage />} />
      <Route path="/reservation/success" element={<ReservationPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<ClientDashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/orders/:reservationId/process" element={<OrderProcessingPage />} />
      <Route path="/admin/returns/:returnId/process" element={<ReturnProcessingPage />} />
      <Route path="/admin/inspections/:reservationId/new" element={<InspectionProcessingPage />} />
      <Route path="/cgv" element={<CGVPage />} />
      <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
      <Route path="/confidentialite" element={<ConfidentialitePage />} />
      <Route path="/sepa/pending/:requestId" element={<SEPAPendingPage />} />
      <Route path="/sepa-sign/:requestId" element={<SEPASignPage />} />
      <Route path="/quote-accept/:quoteId" element={<QuoteAcceptPage />} />
      <Route path="/light" element={<LightPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors closeButton toastOptions={{ duration: 3000, error: { duration: 5000 } }} />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <CookieBanner />
    </div>
  );
}

export default App;
